// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.problems {
  max-width: 1386px;
  margin: 200px auto 200px auto;
  display: flex;
  flex-direction: column;
}

.problems__header-container {
  display: flex;
  margin: 0 0 70px 0;
}

.problems__header-container_type_mobile {
  flex-direction: column;
}

.problems__header-line {
  width: 390px;
  height: 1px;
  background-color: white;
  margin: 35px 24px 0 0;
}

.problems__header {
  font-family: "Playfair Display";
  font-weight: 500;
  font-size: 60px;
  line-height: 50px;
  margin: 0;
  padding: 0;
}

.problems__header-lines {
  display: flex;
  flex-direction: column;
}

.problems__header-first-line {
  font-family: "Playfair Display";
  font-weight: 500;
  font-size: 26px;
  line-height: 36px;
  margin: 0;
  padding: 0;
}

.problems__header-second-line {
  font-family: "Playfair Display";
  font-weight: 500;
  font-size: 26px;
  line-height: 36px;
  margin: 0;
  padding: 0;
}

.problems__description {
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  margin: 0 auto 70px 0;
  padding: 0;
}

.problems__bubbles-section {
  display: flex;
  flex-direction: column;
}

.problems__bubble-row {
  display: flex;
  margin: 0 auto 70px auto;
}

.problems__bubble-row:last-of-type {
  margin: 0 auto;
}

.problems__bubble {
  display: flex;
  width: 300px;
  height: 300px;
  border: 2px solid white;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  margin-right: 60px;
}

.problems__bubble_no-margin {
  margin-right: 0;
}

.problems__bubble-problem {
  font-family: "Playfair Display";
  font-weight: 600;
  font-size: 24px;
  line-height: 50px;
  text-align: center;
}

@media screen and (max-width: 1439px) {
  .problems {
    max-width: 984px;
    margin: 100px auto 100px auto;
  }

  .problems__header-line {
    background-color: white;
    margin: 35px 24px 0 0;
  }

  .problems__header {
    font-size: 45px;
    line-height: 55px;
  }

  .problems__description {
    margin: 0 auto 40px 0;
  }

  .problems__bubble-row {
    margin: 0 auto 35px auto;
  }

  .problems__bubble {
    width: 200px;
    height: 200px;
    margin-right: 55px;
  }

  .problems__bubble_no-margin {
    margin-right: 0;
  }

  .problems__bubble-problem {
    font-size: 18px;
    line-height: 30px;
    text-align: center;
  }
}

@media screen and (max-width: 1024px) {
  .problems {
    max-width: 708px;
    margin: 75px auto 75px auto;
  }

  .problems__header-container {
    margin: 0 0 35px 0;
  }

  .problems__header-line {
    width: 100px;
    height: 1px;
    margin: 25px 10px 0 0;
  }

  .problems__header {
    font-size: 35px;
    line-height: 45px;
  }

  .problems__description {
    font-size: 16px;
    line-height: 24px;
    margin: 0 auto 35px 0;
    padding: 0;
  }

  .problems__bubble-row > .problems__bubble:last-of-type {
    margin-right: 0;
  }
}

@media screen and (max-width: 763px) {
  .problems {
    max-width: 320px;
    margin: 100px auto 100px auto;
    justify-content: center;
    align-items: center;
  }

  .problems__header-container {
    display: flex;
    margin: 0 0 80px 0;
  }

  .problems__header-line {
    display: inline-block;
    width: 150px;
    margin: 0px 20px 10px 0;
  }

  .problems__description {
    text-align: center;
    margin: 0 auto 82px 0;
    padding: 0;
  }

  .problems__bubbles-section {
    align-items: center;
    justify-content: center;
  }

  .problems__bubble-row {
    margin: 0 auto 20px auto;
  }

  .problems__bubble {
    width: 150px;
    height: 150px;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
  }

  .problems__bubble:nth-of-type(2n),
  .problems__bubble:last-of-type {
    margin-right: 0;
  }

  .problems__bubble-problem {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Problems/Problems.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,6BAA6B;IAC7B,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".problems {\r\n  max-width: 1386px;\r\n  margin: 200px auto 200px auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.problems__header-container {\r\n  display: flex;\r\n  margin: 0 0 70px 0;\r\n}\r\n\r\n.problems__header-container_type_mobile {\r\n  flex-direction: column;\r\n}\r\n\r\n.problems__header-line {\r\n  width: 390px;\r\n  height: 1px;\r\n  background-color: white;\r\n  margin: 35px 24px 0 0;\r\n}\r\n\r\n.problems__header {\r\n  font-family: \"Playfair Display\";\r\n  font-weight: 500;\r\n  font-size: 60px;\r\n  line-height: 50px;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.problems__header-lines {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.problems__header-first-line {\r\n  font-family: \"Playfair Display\";\r\n  font-weight: 500;\r\n  font-size: 26px;\r\n  line-height: 36px;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.problems__header-second-line {\r\n  font-family: \"Playfair Display\";\r\n  font-weight: 500;\r\n  font-size: 26px;\r\n  line-height: 36px;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.problems__description {\r\n  font-weight: 500;\r\n  font-size: 20px;\r\n  line-height: 28px;\r\n  margin: 0 auto 70px 0;\r\n  padding: 0;\r\n}\r\n\r\n.problems__bubbles-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.problems__bubble-row {\r\n  display: flex;\r\n  margin: 0 auto 70px auto;\r\n}\r\n\r\n.problems__bubble-row:last-of-type {\r\n  margin: 0 auto;\r\n}\r\n\r\n.problems__bubble {\r\n  display: flex;\r\n  width: 300px;\r\n  height: 300px;\r\n  border: 2px solid white;\r\n  border-radius: 50%;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-right: 60px;\r\n}\r\n\r\n.problems__bubble_no-margin {\r\n  margin-right: 0;\r\n}\r\n\r\n.problems__bubble-problem {\r\n  font-family: \"Playfair Display\";\r\n  font-weight: 600;\r\n  font-size: 24px;\r\n  line-height: 50px;\r\n  text-align: center;\r\n}\r\n\r\n@media screen and (max-width: 1439px) {\r\n  .problems {\r\n    max-width: 984px;\r\n    margin: 100px auto 100px auto;\r\n  }\r\n\r\n  .problems__header-line {\r\n    background-color: white;\r\n    margin: 35px 24px 0 0;\r\n  }\r\n\r\n  .problems__header {\r\n    font-size: 45px;\r\n    line-height: 55px;\r\n  }\r\n\r\n  .problems__description {\r\n    margin: 0 auto 40px 0;\r\n  }\r\n\r\n  .problems__bubble-row {\r\n    margin: 0 auto 35px auto;\r\n  }\r\n\r\n  .problems__bubble {\r\n    width: 200px;\r\n    height: 200px;\r\n    margin-right: 55px;\r\n  }\r\n\r\n  .problems__bubble_no-margin {\r\n    margin-right: 0;\r\n  }\r\n\r\n  .problems__bubble-problem {\r\n    font-size: 18px;\r\n    line-height: 30px;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1024px) {\r\n  .problems {\r\n    max-width: 708px;\r\n    margin: 75px auto 75px auto;\r\n  }\r\n\r\n  .problems__header-container {\r\n    margin: 0 0 35px 0;\r\n  }\r\n\r\n  .problems__header-line {\r\n    width: 100px;\r\n    height: 1px;\r\n    margin: 25px 10px 0 0;\r\n  }\r\n\r\n  .problems__header {\r\n    font-size: 35px;\r\n    line-height: 45px;\r\n  }\r\n\r\n  .problems__description {\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    margin: 0 auto 35px 0;\r\n    padding: 0;\r\n  }\r\n\r\n  .problems__bubble-row > .problems__bubble:last-of-type {\r\n    margin-right: 0;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 763px) {\r\n  .problems {\r\n    max-width: 320px;\r\n    margin: 100px auto 100px auto;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .problems__header-container {\r\n    display: flex;\r\n    margin: 0 0 80px 0;\r\n  }\r\n\r\n  .problems__header-line {\r\n    display: inline-block;\r\n    width: 150px;\r\n    margin: 0px 20px 10px 0;\r\n  }\r\n\r\n  .problems__description {\r\n    text-align: center;\r\n    margin: 0 auto 82px 0;\r\n    padding: 0;\r\n  }\r\n\r\n  .problems__bubbles-section {\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .problems__bubble-row {\r\n    margin: 0 auto 20px auto;\r\n  }\r\n\r\n  .problems__bubble {\r\n    width: 150px;\r\n    height: 150px;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-right: 10px;\r\n  }\r\n\r\n  .problems__bubble:nth-of-type(2n),\r\n  .problems__bubble:last-of-type {\r\n    margin-right: 0;\r\n  }\r\n\r\n  .problems__bubble-problem {\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 24px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
